import { render, staticRenderFns } from "./TeacherSignInLayout.vue?vue&type=template&id=398c71c6&lang=pug&"
import script from "./TeacherSignInLayout.vue?vue&type=script&lang=ts&"
export * from "./TeacherSignInLayout.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherSignInLayout.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports